import React from 'react'
import Modal from 'react-responsive-modal'
import { Input, Textarea} from '../../../components/ModalInputs'
import { useFormik } from 'formik'
import * as Yup from 'yup'
import { createItem } from '../../../actions/webLessons'
import Button from '../../../components/Button'
import { useDispatch } from 'react-redux'
import styles from '../styles.module.scss'


const initialValues = {
  stream: '',
  started: '',
  description: ''
}

const validationSchema = Yup.object({
  stream: Yup.string().required('обязательное поле'),
  started: Yup.string().required('обязательное поле'),
  description: Yup.string().required('обязательное поле'),
})

const AddEditModal = ({open, closeModal, addMode}) => {
  
  const dispatch = useDispatch()

  const onSubmit = () => {
    const success = dispatch(createItem(values))
    success && closeModal()
  }

  const {values, handleChange, setFieldValue, handleSubmit} = useFormik({ initialValues, validationSchema, onSubmit })
  
  
  return (
    <Modal
      open={open}
      onClose={closeModal}
      classNames={{modal: styles.addEditModal}}
      showCloseIcon={false}
      center
    >
      <h1>Добавление урока</h1>

      <Input
        label='Название урока'
        name='stream'
        value={values.stream}
        onChange={handleChange}
      />

      <Textarea
        label='Описание урока'
        name='description'
        value={values.description}
        onChange={handleChange}
      />

      <Input
        label='Начало урока'
        name='started'
        type='datetime-local'
        value={values.started}
        onChange={handleChange}
      />

      <div>
        <Button onClick={handleSubmit}>Сохранить</Button>
        <Button onClick={closeModal}>Отменить</Button>
      </div>

    </Modal>
  )
}

export default AddEditModal